.g3{z-index:2;}